import { useId, type ReactNode } from 'react'
import { AlertTriangle } from 'lucide-react'

import { Button } from '@/shared/components/ui/button'
import { cn } from '@/shared/lib/utils'

interface ErrorStateProps {
  title: string
  description?: string
  retryLabel?: string
  onRetry?: () => void
  children?: ReactNode
  className?: string
}

export function ErrorState({ title, description, retryLabel, onRetry, children, className }: ErrorStateProps) {
  const titleId = useId()

  return (
    <section
      role="alert"
      aria-labelledby={titleId}
      className={cn('rounded-lg border border-destructive/30 bg-destructive/5 px-6 py-8 text-center', className)}
    >
      <AlertTriangle className="mx-auto mb-4 size-10 text-destructive" aria-hidden />
      <h2 id={titleId} className="text-lg font-semibold text-foreground">
        {title}
      </h2>
      {description ? <p className="mt-2 text-sm text-muted-foreground">{description}</p> : null}
      {children}
      {onRetry && retryLabel ? (
        <div className="mt-6">
          <Button type="button" variant="outline" size="sm" onClick={onRetry}>
            {retryLabel}
          </Button>
        </div>
      ) : null}
    </section>
  )
}
